export default class Achievement
{
    constructor(id, group, name, icon = PIXI.Texture.EMPTY)
    {
        this._id = id;
        this._group = group;
        this._name = name;
        this._icon = icon;
    }

    get id()
    {
        return this._id;
    }

    get group()
    {
        return this._group;
    }

    get name()
    {
        return this._name;
    }

    get icon()
    {
        return this._icon;
    }
}

Achievement.FACE_THE_GOLDEN_DRAGON = 0;

Achievement.XP_LEVEL1 = 1;
Achievement.XP_LEVEL2 = 2;
Achievement.XP_LEVEL3 = 3;
Achievement.XP_LEVEL4 = 4;
Achievement.XP_LEVEL5 = 5;
Achievement.XP_LEVEL6 = 6;
Achievement.XP_LEVEL7 = 7;

Achievement.COMPLETE_TWO_TOPIC_DAY = 10;

Achievement.ANSWER_QUESTIONS_LEVEL1 = 20;
Achievement.ANSWER_QUESTIONS_LEVEL2 = 21;

Achievement.COMPLETE_CHALLENGES_LEVEL1 = 30;
Achievement.COMPLETE_CHALLENGES_LEVEL2 = 31;
Achievement.COMPLETE_CHALLENGES_LEVEL3 = 32;
Achievement.COMPLETE_CHALLENGES_LEVEL4 = 33;
Achievement.COMPLETE_CHALLENGES_LEVEL5 = 34;

Achievement.COMPLETE_DRAGON_LEVEL1 = 40;
Achievement.COMPLETE_DRAGON_LEVEL2 = 41;
Achievement.COMPLETE_DRAGON_LEVEL3 = 42;
Achievement.COMPLETE_DRAGON_LEVEL4 = 43;
Achievement.COMPLETE_DRAGON_LEVEL5 = 44;

Achievement.COMPLETE_HOBGOBLIN_LEVEL1 = 50;
Achievement.COMPLETE_HOBGOBLIN_LEVEL2 = 51;
Achievement.COMPLETE_HOBGOBLIN_LEVEL3 = 52;
Achievement.COMPLETE_HOBGOBLIN_LEVEL4 = 53;
Achievement.COMPLETE_HOBGOBLIN_LEVEL5 = 54;

Achievement.COMPLETE_MAGE_LEVEL1 = 60;
Achievement.COMPLETE_MAGE_LEVEL2 = 61;
Achievement.COMPLETE_MAGE_LEVEL3 = 62;
Achievement.COMPLETE_MAGE_LEVEL4 = 63;
Achievement.COMPLETE_MAGE_LEVEL5 = 64;

Achievement.COMPLETE_SPIDER_LEVEL1 = 70;
Achievement.COMPLETE_SPIDER_LEVEL2 = 71;
Achievement.COMPLETE_SPIDER_LEVEL3 = 72;
Achievement.COMPLETE_SPIDER_LEVEL4 = 73;
Achievement.COMPLETE_SPIDER_LEVEL5 = 74;

Achievement.COMPLETE_SPIRIT_LEVEL1 = 80;
Achievement.COMPLETE_SPIRIT_LEVEL2 = 81;
Achievement.COMPLETE_SPIRIT_LEVEL3 = 82;
Achievement.COMPLETE_SPIRIT_LEVEL4 = 83;
Achievement.COMPLETE_SPIRIT_LEVEL5 = 84;

Achievement.COMPLETE_TROLL_LEVEL1 = 90;
Achievement.COMPLETE_TROLL_LEVEL2 = 91;
Achievement.COMPLETE_TROLL_LEVEL3 = 92;
Achievement.COMPLETE_TROLL_LEVEL4 = 93;
Achievement.COMPLETE_TROLL_LEVEL5 = 94;

Achievement.UNLOCK_ALL_BRACELETS = 100;
Achievement.UNLOCK_ALL_AMULETS = 110;
Achievement.UNLOCK_ALL_BELTS = 120;
Achievement.UNLOCK_ALL_CLOAKS = 130;
Achievement.UNLOCK_ALL_FEATHERS = 140;
Achievement.UNLOCK_ALL_PURSES = 150;
Achievement.UNLOCK_ALL_SHIELDS = 160;
Achievement.UNLOCK_ALL_PETS = 170;